import { render, staticRenderFns } from "./TarificationsShow.vue?vue&type=template&id=0a589e34&"
import script from "./TarificationsShow.vue?vue&type=script&lang=js&"
export * from "./TarificationsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports